import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useCookies} from 'react-cookie';
import {Fragment} from 'react';
import {useSelector, useDispatch} from 'react-redux';

const Interceptor = () => {
    const [authInterceptor, setAuthInterceptor] = useState();
    const [cookies] = useCookies(['token']);
    // const accessToken = useSelector(state => state?.auth?.data?.token || null);

    const SKIP_AUTH_URLS = [
        '/auth',
        '/login',
        '/refresh',
    ];

    const shouldSkipAuth = (url = '') =>
        SKIP_AUTH_URLS.some(path => url.includes(path)) ||
        url.includes('https://maps.googleapis.com') ||
        url.includes('https://widget.cloudinary.com') ||
        url.includes('https://5d6f64ec482b530014d2e11e.mockapi.io');

    const addAuthInterceptor = () => {
        const interceptorId = axios.interceptors.request.use(
            config => {
                if (shouldSkipAuth(config.url)) {
                    return config;
                }

                const rawToken = cookies.token;
                if (rawToken) {
                    config.headers.Authorization =
                        rawToken.startsWith('Bearer ')
                            ? rawToken
                            : `Bearer ${rawToken}`;
                }

                return config;
            },
            error => Promise.reject(error)
        );

        setAuthInterceptor(interceptorId);
    };

    const removeAuthInterceptor = () => {
        if (authInterceptor !== undefined) {
            axios.interceptors.request.eject(authInterceptor);
        }
    };

    useEffect(() => {
        addAuthInterceptor();
        return removeAuthInterceptor;
    }, []);

    return null;
};

export default Interceptor;
